"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../../utils/hooks");

var _Layout = require("../../Layout");

var _Card = require("./Card.style");

var _CardList = require("./CardList.style");

var _Button = _interopRequireDefault(require("../../Button"));

var _PriceSlash = _interopRequireDefault(require("./PriceSlash/PriceSlash"));

var _AddToCalendar = require("../../AddToCalendar");

var _mainLink = _interopRequireDefault(require("../../Link/mainLink"));

var _MarkdownRenderer = _interopRequireDefault(require("../../MarkdownRenderer"));

var _CardBadge = _interopRequireDefault(require("./CardBadge"));

var CardList = function CardList(_ref) {
  var copy = _ref.copy,
      cta = _ref.cta,
      image = _ref.image,
      price = _ref.price,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      label = _ref.label,
      link = _ref.link,
      date = _ref.date,
      tag = _ref.tag,
      bookmark = _ref.bookmark,
      onClickLabel = _ref.onClickLabel,
      rest = _objectWithoutProperties(_ref, ["copy", "cta", "image", "price", "title", "subtitle", "description", "label", "link", "date", "tag", "bookmark", "onClickLabel"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  var wrapperHeight = ['auto', 'auto', cards.listHeightTablet, cards.listHeight];
  var hasCta = !!cta && !!cta.url && !!cta.label;
  var hasTag = !!tag;

  var _ref3 = (0, _emotionTheming.useTheme)(),
      breakpoints = _ref3.breakpoints;

  var windowWidth = (0, _hooks.useWindowWidth)();
  var isCardChange = windowWidth >= parseInt(breakpoints.medium, 10);

  var CardListWrapper = function CardListWrapper(_ref4) {
    var children = _ref4.children;
    return link && link.url && !hasCta ? /*#__PURE__*/_react.default.createElement(_CardList.CardListContainer, Object.assign({
      as: _mainLink.default,
      to: link.url
    }, link, rest), children) : /*#__PURE__*/_react.default.createElement(_CardList.CardListContainer, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children));
  };

  return /*#__PURE__*/_react.default.createElement(_Card.Wrapper, {
    image: image,
    height: wrapperHeight
  }, /*#__PURE__*/_react.default.createElement(CardListWrapper, null, image && /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: [12, 12, 5, 5],
    px: 0,
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement(_CardList.ListCardImage, Object.assign({
    height: "100%",
    mediaType: "backgroundImage",
    preserveStackingContext: true
  }, image)), label && /*#__PURE__*/_react.default.createElement(_CardBadge.default, {
    label: label,
    variant: "list",
    bookmark: bookmark,
    onClickLabel: onClickLabel
  }), image && bookmark && !isCardChange && /*#__PURE__*/_react.default.createElement(_Card.BookmarkCta, {
    isActive: bookmark.isActive,
    onClick: bookmark.onClick
  })), /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: image ? [12, 12, 7, 7] : [12, 12, 12, 12],
    px: 0
  }, /*#__PURE__*/_react.default.createElement(_CardList.ListCardContent, {
    image: image
  }, /*#__PURE__*/_react.default.createElement(_rebass.Box, null, hasTag && /*#__PURE__*/_react.default.createElement(_CardList.ListCardLabel, {
    size: "xsmall"
  }, tag), title && /*#__PURE__*/_react.default.createElement(_CardList.CardListTitle, {
    size: "xsmall",
    bookmark: bookmark,
    hasTag: hasTag,
    as: "p"
  }, title), image && bookmark && isCardChange && /*#__PURE__*/_react.default.createElement(_CardList.BookmarkDesktop, {
    isActive: bookmark.isActive,
    onClick: bookmark.onClick
  }), subtitle && /*#__PURE__*/_react.default.createElement(_CardList.CardSubtitle, {
    size: "medium",
    bookmark: bookmark
  }, subtitle), description && /*#__PURE__*/_react.default.createElement(_CardList.CardDescription, {
    size: "small",
    bookmark: bookmark
  }, description), /*#__PURE__*/_react.default.createElement(_CardList.ListCardCopyWrap, {
    as: "div",
    size: "small",
    bookmark: bookmark
  }, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: copy,
    copySize: "small"
  }))), /*#__PURE__*/_react.default.createElement(_CardList.ListCardFlex, {
    hasCta: hasCta
  }, hasCta && /*#__PURE__*/_react.default.createElement(_rebass.Box, null, /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: cards.buttonProductCard
  }, cta), cta.label)), price.current && /*#__PURE__*/_react.default.createElement(_PriceSlash.default, Object.assign({
    price: price,
    cards: cards
  }, rest)), date && /*#__PURE__*/_react.default.createElement(_CardList.ListCardLabel, {
    size: "xsmall"
  }, date))))));
};

CardList.propTypes = {
  /** Card copy */
  copy: _propTypes.default.string,

  /** Card Secondary CTA - links to button */
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.oneOf(['primary', 'secondary', 'link']),
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),

  /** Card price -  includes both previous and current price */
  price: _propTypes.default.shape({
    previous: _propTypes.default.string,
    current: _propTypes.default.string
  }),

  /** Card Primary CTA - links to main title and image */
  title: _propTypes.default.string,

  /** Card subtitle - placed under the title */
  subtitle: _propTypes.default.string,

  /** Card label - placed on top of the image */
  label: _propTypes.default.string,

  /** Card details - placed under the subtitle */
  description: _propTypes.default.string,

  /** Card tag - small text placed on top of the title */
  tag: _propTypes.default.string,

  /** Card date - placed under the cta or at the bottom right if there's no cta */
  date: _propTypes.default.string,
  link: _propTypes.default.shape({
    /** card link URL */
    url: _propTypes.default.string
  }),
  isLargeNav: _propTypes.default.bool,
  bookmark: _propTypes.default.shape({
    isActive: _propTypes.default.bool,
    onClick: _propTypes.default.func
  }),
  children: _propTypes.default.node,
  onClickLabel: _propTypes.default.func
};
CardList.defaultProps = {
  copy: '',
  cta: {
    label: null,
    url: null,
    calendarEvent: null
  },
  description: '',
  label: null,
  price: {
    previous: '',
    current: ''
  },
  title: '',
  subtitle: '',
  tag: '',
  date: '',
  link: null,
  image: null,
  isLargeNav: false,
  bookmark: null,
  children: null,
  onClickLabel: null
};
var _default = CardList;
exports.default = _default;